/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'time': {
    width: 18,
    height: 18,
    viewBox: '0 0 24 24',
    data: '<circle pid="0" cx="12" cy="12" r="10"/><path pid="1" d="M12 6v6l4 2"/>'
  }
})
